import { MuiTheme, createStyles, makeStyles } from '@kis-technologies/kis-ui';

export const useStyles = (props: { isLoggedIn: boolean }) =>
  makeStyles((theme: MuiTheme) =>
    createStyles({
      routeOuterContainer: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        background: 'transparent',
        padding: '0px 72px 0px 72px',
        margin: '0px 0px 32px 0px',
        [theme.breakpoints.down('sm')]: {
          margin: '-10px 0px 23px 0px',
          padding: '0px 16px 0px 20px',
          alignItems: 'center',
          justifyContent: 'center'
        },
        [theme.breakpoints.down('xs')]: {
          justifyContent: props.isLoggedIn ? 'start' : 'center'
        }
      },
      routeSelectClient: {
        display: 'box',
        [theme.breakpoints.down('sm')]: {
          display: 'none'
        }
      },
      routeContainer: {
        maxWidth: '1400px',
        margin: '0 auto',
        padding: '0px 20px 0px 20px',
        [theme.breakpoints.down('xs')]: {
          padding: '0px 0px 0px 0px'
        }
      },
      routeButtonBox: {
        display: 'none',
        [theme.breakpoints.down('sm')]: {
          display: props.isLoggedIn ? 'flex' : 'none',
          position: 'absolute',
          left: '25px'
        },
        [theme.breakpoints.down('xs')]: {
          display: props.isLoggedIn ? 'flex' : 'none',
          position: 'relative',
          left: 'auto',
          paddingRight: '25px'
        }
      },
      routeMenuButton: {
        width: '69px',
        height: '33px',
        background: 'transparent',
        border: 'solid 2px #4B4B4B',
        backgroundColor: '#EFEFEF',
        color: '#4B4B4B'
      },
      routeKioskImage: {
        '& > * ': {
          [theme.breakpoints.down('xs')]: {
            height: '37px'
          }
        }
      }
    })
  );

export const useStylesDashboard = makeStyles((theme: MuiTheme) =>
  createStyles({
    dashboardOuterContainer: {
      borderRadius: '32px 32px 0px 0px',
      height: '914px'
    },
    dashboardSideTabs: {
      display: 'flex',
      [theme.breakpoints.down('sm')]: {
        display: 'none'
      }
    },
    dashboardInnerContainer: {
      width: 'calc(100% - 236px)',
      background: 'transparent',
      minHeight: 'calc(100vh - 125px)',
      display: 'flex',
      [theme.breakpoints.down('sm')]: {
        width: '100%'
      }
    },
    activeCustomerText: {
      fontSize: '16px',
      lineHeight: '1.5',
      fontWeight: 600,
      textAlign: 'center',
      color: '#999999'
    }
  })
);
